import React from "react";
import ErrorHandler from "../../class/ErrorHandler";
import  * as requestLib from '../../lib/requestLib'
import SelectRefresh from './SelectRefresh'
import UserInfo from './UserInfo'
import ShareUser from './ShareUser'


class Item extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        } 

        this.errorHandler = new ErrorHandler(this);
        this.baseUrl = requestLib.getUrl();
    }

    getInfo() {

        let type = this.props.type;
        
        if(type==="refresh") return <SelectRefresh/>
        else if(type==="userInfo") return <UserInfo/> 
        else if(type==="shareUser") return <ShareUser/> 
 
    }

    render() {
        
        try {
            return (
                <div className="right">
                    {this.getInfo()}
                </div>
            )
        } catch (error) {
            this.errorHandler.processError(error);
            return null;
        }
    }
}

export default Item;
